// Sockets
import { io } from 'socket.io-client';
// config
import { PUSH_NOTIFICATIONS_API } from 'src/config-global';

export const socketInstance = io(PUSH_NOTIFICATIONS_API.api, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
  timeout: 20000
});